<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <!-- <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="模板名称:">
                    <el-input
                        class="s-input"
                        v-model="queryParams.code"
                        placeholder="请输入模板名称"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="计算时间:">
                    <el-select
                        v-model="queryParams.ty"
                        placeholder="请选择计算时间"
                        clearable
                        @change="changeQuery"
                    >
                        <el-option label="按件数" :value="1"></el-option>
                        <el-option label="按重量" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="loadData()">搜索</el-button>
                </div>
            </el-form>-->
            <div class="action">
                <el-button type="primary" @click="add()">新增运费模板</el-button>
            </div>
            <!-- 表格内容 -->
            <el-table v-loading="loading" element-loading-text="数据加载中" stripe border :data="pageInfo.list">
                <el-table-column label="可配送区域" prop="name" width="200" align="center"></el-table-column>
                <el-table-column label="首件(个)" prop="first" width="200" align="center"></el-table-column>
                <el-table-column label="运费(元)" prop="first_price" width="200" align="center"></el-table-column>
                <el-table-column label="续件(个)" prop="renew" width="200" align="center"></el-table-column>
                <el-table-column label="续费(元)" prop="renew_price" width="200" align="center"></el-table-column>
                <el-table-column label="收费类型" prop="ty" width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.ty === 1">按件数</el-tag>
                        <el-tag type="success" v-if="scope.row.ty === 2">按重量</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.state === 1">下线</el-tag>
                        <el-tag type="success" v-if="scope.row.state === 2">上线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="setDefault(scope.$index, scope.row)">设为默认</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="copy(scope.$index, scope.row)">复制</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="delete(scope.$index, scope.row)">删除</el-button>
                        <!-- <el-button
                            v-if="scope.row.state === 2"
                            type="text"
                            class="red"
                            @click="state(scope.row, 1)"
                        >下线</el-button>
                        <el-button
                            v-if="scope.row.state === 1"
                            type="text"
                            class="green"
                            @click="state(scope.row, 2)"
                        >上线</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 编辑添加运费模板 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="80%">
            <el-form class="form_box" ref="form" v-bind:rules="rules" v-bind:model="form" v-loading.body="loading" label-position="right" label-suffix=":" label-width="100px" size="large" element-loading-text="上传中">
                <!-- <el-form-item label="可配送区域" prop="uid">
                    <el-input v-model="form.uid" placeholder="请输入可配送区域"></el-input>
                </el-form-item>
                <el-form-item label="首件" prop="uid">
                    <el-input v-model="form.uid" placeholder="请输入首件数量"></el-input>
                </el-form-item>
                <el-form-item label="运费" prop="uid">
                    <el-input v-model="form.uid" placeholder="请输入运费"></el-input>
                </el-form-item>
                <el-form-item label="续件" prop="uid">
                    <el-input v-model="form.uid" placeholder="请输入续件数量"></el-input>
                </el-form-item>
                <el-form-item label="续费" prop="uid">
                    <el-input v-model="form.uid" placeholder="请输入续费数量"></el-input>
                </el-form-item>
                <el-form-item label="计算时间" prop="ty">
                    <el-select v-model="form.ty" placeholder="请选择计算时间">
                        <el-option label="按件数" v-bind:value="1"></el-option>
                        <el-option label="按重量" v-bind:value="2"></el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item label="模板名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入模板名称"></el-input>
                </el-form-item>
                <el-form-item label="计算方式" prop="ty">
                    <el-radio-group v-model="form.ty">
                        <el-radio :label="2">按件数</el-radio>
                        <el-radio :label="1">按重量</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="配送区域" prop="region">
                    <!-- 表格内容 -->
                    <el-table class="form_table" v-loading="loading" element-loading-text="数据加载中" stripe border :data="regionList" @cell-click="cellClick">
                        <el-table-column label="可配送区域" align="center">
                            <template slot-scope="scope">
                                <el-checkbox v-if="scope.$index ===0" v-model="scope.row.checked" @change="allClick(scope.$index,scope.row)">{{scope.row.region}}</el-checkbox>
                                <el-checkbox v-else v-model="scope.row.checked" @change="check_one(scope.$index,scope.row)">{{scope.row.region}}</el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column label="首件(个)" prop="first" width="200" align="center">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.seen" size="small" v-model="scope.row.first" @blur="loseFcous(scope.$index, scope.row)"></el-input>
                                <span style="margin-left: 10px" v-else>{{ scope.row.first }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="运费(元)" prop="express" width="200" align="center">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.seen" size="small" v-model="scope.row.express" @blur="loseFcous(scope.$index, scope.row)"></el-input>
                                <span style="margin-left: 10px" v-else>{{ scope.row.express }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="续件(个)" prop="next" width="200" align="center">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.seen" size="small" v-model="scope.row.next" @blur="loseFcous(scope.$index, scope.row)"></el-input>
                                <span style="margin-left: 10px" v-else>{{ scope.row.next }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="续费(元)" prop="price" width="200" align="center">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.seen" size="small" v-model="scope.row.price" @blur="loseFcous(scope.$index, scope.row)"></el-input>
                                <span style="margin-left: 10px" v-else>{{ scope.row.price }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="会员等级" prop="ty" width="200" align="center">
                            <template slot-scope="scope">
                                <el-tag type="primary" v-if="scope.row.ty === 1">按件数</el-tag>
                                <el-tag type="success" v-if="scope.row.ty === 2">按重量</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" fixed="right">
                            <template slot-scope="scope"></template>
                        </el-table-column>-->
                    </el-table>
                    <!-- 分页 -->
                    <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addNewRegion">添加可配送区域及运费</el-button>
                    <p>未特殊编辑的地区，按默认设置规则算计</p>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">保存</el-button>
            </div>
        </el-dialog>
        <!-- 编辑添加运费区域 -->
        <el-dialog title="选择包邮区域" :visible.sync="addRegion" width="80%">
            <el-form class="form_box" ref="form" v-bind:rules="rules" v-bind:model="form" v-loading.body="loading" label-position="right" label-suffix=":" label-width="100px" size="large" element-loading-text="上传中">
                <el-form-item label="省" prop="sheng">
                    <el-checkbox-group v-model="aa.sheng" @change="changSheng">
                        <el-checkbox @change="changOneSheng" v-for="item in shengList" :label="item.name" :key="item.id"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="市" prop="shi" @change="changshi">
                    <el-checkbox-group v-model="aa.shi">
                        <el-checkbox v-for="item in shiList" :label="item.name" :key="item.id"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="区" prop="qu">
                    <el-checkbox-group v-model="aa.qu">
                        <el-checkbox v-for="item in quList" :label="item.name" :key="item.id"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="allRegion = false">全选</el-button>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addRegion = false">取 消</el-button>
                <el-button type="primary" @click="choice">选择</el-button>
            </div>
        </el-dialog>
        <!-- 上线、下线提示框 -->
        <!-- <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>-->
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb'
import Pagination from '@/components/Pagination'
import { request } from '@/common/request'
import { deal } from '@/common/main'
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            menuList: ['设置', '配送设置'],
            loading: false,
            confirmVisible: false,
            confirmContent: '',
            addRegion: false,
            queryParams: {
                page: 1,
                pagesize: 10,
            },
            pageInfo: {},
            addVisible: false,
            addVisibles: false,
            title: '添加配送设置',
            rules: {
                name: [
                    { required: true, message: '商城名称不能为空', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },

            mode: 'add',
            form: {
                countType: 1,
                num: 1,
                countType: 1,
                ty: 1,
            },
            all_checked: false,
            regionList: [
                {
                    region: '默认设置，所有区域均参与配送',
                    first: 1,
                    express: 1,
                    next: 1,
                    price: 1,
                    checked: false
                },
                {
                    region: '啦啦啦',
                    first: 1,
                    express: 1,
                    next: 1,
                    price: 1,
                    checked: false
                },
                {
                    region: '我我我',
                    first: 1,
                    express: 1,
                    next: 1,
                    price: 1,
                    checked: false
                },
            ],
            shengList: [
                {
                    id: 1,
                    name: '河南省'
                },
                {
                    id: 2,
                    name: '江西省'
                }
            ],
            shiList: [
                {
                    id: 1,
                    name: '南阳市'
                },
                {
                    id: 2,
                    name: '洛阳市'
                }
            ],
            quList: [
                {
                    id: 1,
                    name: '卧龙区'
                },
                {
                    id: 2,
                    name: '啦啦啦'
                }],
            aa: {
                sheng: ['河南省'],
                shi: ['南阳市'],
                qu: ['卧龙区']
            }
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            // this.loading = true;
            //配送设置列表
            request.get('/common/express/template/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    console.log(22222, this.pageInfo)
                    this.pageInfo.list = ret.data.list;
                    // this.pageInfo.list.map(function (val) {
                    //     val.time = val.time + '天'
                    //     return val;
                    // })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1
            this.loadData()
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val
            this.loadData()
        },
        // 新增运费模板 
        add(id, index) {
            this.mode = 'add';
            this.form = {}
            this.regionList = [{
                region: '默认设置，所有区域均参与配送',
                first: 1,
                express: 1,
                next: 1,
                price: 1,
                checked: false
            }]
            this.addVisible = true
        },
        //编辑运费模板 
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑';
            const item = this.pageInfo.list[index];
            let time = [item.stime, item.etime]
            //处理时间
            this.form = Object.assign([], item);
            // console.log(4444,this.form)
            this.$set(this.form, 'time', time);
            console.log(1111111, this.form)
            this.addVisible = true;
        },
        // 删除运费模板 
        delete(id, index) {

        },
        changeCount(num) {
            this.form.num = num
        },

        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        //   this.form.num = this.form.countType == 1 ? 1 : this.form.num;
                        // this.form.brand_ids = this.form.brand_id;
                        var url = this.mode == 'add' ? '/plug/invitation/add' : '/plug/invitation/edit';
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.addVisibles = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            };
        },
        // 确定下线
        stateData() {
            request.post('', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 新增运费地区 
        addNewRegion() {
            this.aa.sheng = ['河南省']
            this.addRegion = true
        },
        // 选择地区
        choice() {
            let arr = []
            console.log(this.aa)
            this.aa.sheng.map(itemsheng =>
                this.aa.shi.map(itemshi =>
                    this.aa.qu.map(itemqu =>
                        arr.push(
                            {
                                region: `${itemsheng}${itemshi}${itemqu}`,
                                first: null,
                                express: null,
                                next: null,
                                price: null,
                                checked: false
                            }
                        )
                    )
                )
            )
            console.log(55555, arr)
            this.regionList = [...this.regionList, ...arr]
            this.addRegion = false
        },
        changOneSheng(val) {
            // console.log(val)
        },
        // 单选省
        changSheng(val) {
            console.log(val)
            if (this.aa.sheng.length > 1) {
                this.aa.sheng.splice(0, 1)
            }
        },
        // 单选市
        changshi() {
            console.log(this.aa)
            if (this.aa.shi.length > 1) {
                this.aa.shi.splice(0, 1)
            }
        },
        // 地区全选
        allRegion() {

        },
        // 全选 
        allClick(ind, row) {
            this.all_checked = !this.all_checked
            let _this = this
            this.regionList.forEach((item, index, array) => {
                if (_this.all_checked) item.checked = true
                else item.checked = false
            });
        },
        // 单选 
        check_one(ind, row) {
            let _this = this
            let arr = this.regionList.slice(0)
            arr = arr.splice(1)
            var to = setTimeout(function () {
                let falg = arr.every(x => x.checked === false);
                if (falg) _this.regionList[0].checked = false
                else _this.regionList[0].checked = true
            }, 300);
        },
        // 可编辑单元格
        loseFcous(index, row) {
            this.$set(row, 'seen', false)
        },
        // 单元格编辑
        cellClick(row, column) {
            this.$set(row, 'seen', true)
        },
        changeDatePicker: function () {
            let vue = this
            if (vue.pickerDatad != null) {
                vue.form.stime = vue.pickerDatad[0]
                vue.form.etime = vue.pickerDatad[1]
            } else {
                vue.form.stime = null
                vue.form.etime = null
            }
        },
    }
}

</script>

<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}
/* .form_table >>> thead .el-table-column--selection .cell {
    display: none;
} */
</style>